import { applyMiddleware, combineReducers, compose, createStore } from "redux";

import auth from "./ducks/auth";
import configs from "./ducks/configs";
import global from "./ducks/global";
import localization from "./ducks/localization";
import rum from "./ducks/rum";
import users from "./ducks/users";
import consents from "./ducks/consents";
import dashboardFilters from "./ducks/dashboardFilters";
import markets from "./ducks/markets";
import apps from "./ducks/apps";
import notifications from "./ducks/notifications";
import fwuCampaigns from "./ducks/fwuCampaigns";
import notificationCampaigns from "./ducks/notificationCampaigns";
import fwuVersions from "./ducks/fwuVersions";
import fleetManagement from "./ducks/fleetManagement";
import dashboard from "./ducks/dashboard";
import deviceChangeHistory from "./ducks/deviceChangeHistory";
import userGroups from "./ducks/userGroups";
import deviceGroups from "./ducks/deviceGroups";
import hardware from "./ducks/hardware";
import userInsights from "./ducks/userIsights";

let dispatch;
let getState;

const configureStore = (initialState = {}) => {
  const appReducer = combineReducers({
    auth,
    configs,
    global,
    localization,
    rum,
    users,
    dashboardFilters,
    consents,
    markets,
    apps,
    notifications,
    fwuCampaigns,
    notificationCampaigns,
    fwuVersions,
    fleetManagement,
    dashboard,
    deviceChangeHistory,
    userGroups,
    deviceGroups,
    hardware,
    userInsights
  });

  const rootReducer = (state, action) => {
    return appReducer(state, action);
  };

  const middlewares = [];

  if (process.env.NODE_ENV === `development`) {
    const { logger } = require(`redux-logger`);

    middlewares.push(logger);
  }

  const middleware = applyMiddleware(...middlewares);

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(rootReducer, initialState, composeEnhancers(middleware));
  dispatch = store.dispatch;
  getState = store.getState;

  return store;
};

export { configureStore, dispatch, getState };
